import { useEffect, useRef } from 'react'
import { type Swiper as SwiperType } from 'swiper'

import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { useDidUpdateEffect } from '@/app/hooks/useLifecycleEffects'
import { checkboxBadgedTransitionDuration } from '@/components/shared/checkbox/ui/AppCheckboxBadged'

type Props = {
  selectedItems?: string[]
}

export const useCheckboxListSwiper = ({ selectedItems }: Props) => {
  const swiperRef = useRef<SwiperType | null>(null)

  const { breakpoint } = useCurrentBreakpoint()
  const isDesktopScreen = [ScreenSize.Xl, ScreenSize.Xxl].includes(breakpoint)

  useDidUpdateEffect(() => {
    const timeout = setTimeout(() => {
      if (isDesktopScreen) {
        return
      }

      const swiper = swiperRef.current
      if (!swiper || swiper.destroyed) {
        return
      }
      const translate = swiper.getTranslate()
      swiper.update()
      swiper.setTranslate(translate)
    }, checkboxBadgedTransitionDuration)

    return () => clearTimeout(timeout)
  }, [selectedItems])

  useEffect(
    () => () => {
      swiperRef.current = null
    },
    []
  )

  return {
    swiperRef,
    showSwiper: !isDesktopScreen
  }
}
